import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, Table } from "react-bootstrap";
import { getInactiveUserList } from "../../../services/api_function";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";

export const InActiveUser = () => {
  const itemsPerPage = 10; // Items per page
  const [apiData, setApiData] = useState([]); // Data for the table
  const [TotalUsers, setTotalUsers] = useState(0); // Total number of users
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [search, setSearch] = useState(""); // Search query
  const [filteredData, setFilteredData] = useState([]); // Filtered search results
  const [isSearching, setIsSearching] = useState(false); // Search flag
  const [tooltipText, setTooltipText] = useState("Copy address"); // Tooltip text for copying

  // Handle copying address to clipboard
  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    setTooltipText("Copied!");
    setTimeout(() => setTooltipText("Copy address"), 2000); // Reset tooltip text after 2 seconds
  };

  // Fetch data from API when page or search query changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getInactiveUserList(currentPage, itemsPerPage); // Fetch data with page and limit
        console.log(result?.data, "API Response for Inactive Users");
        if (result?.status === 200) {
          setApiData(result?.data?.data); // Set the fetched data
          setTotalUsers(result?.data?.pagination?.total); // Set the total number of users
          setTotalPages(result?.data?.pagination?.totalPages); // Set the total pages for pagination
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currentPage]);

  // Handle search functionality
  const handleSearch = async (e) => {
    const query = e.target.value.trim().toLowerCase();
    const sanitizedQuery = query.replace(/[\\|^$*+?.(){}[\]]/g, "");
    setSearch(sanitizedQuery);

    if (query === "") {
      setIsSearching(false);
      setFilteredData([]);
    } else {
      const results = apiData.filter((item) =>
        item.user_address?.toLowerCase().includes(query),
      );
      setFilteredData(results);
      setIsSearching(true);
    }

    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  // Handle "Next" page click
  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage < totalPages ? prevPage + 1 : prevPage,
    );
  };

  // Handle "Previous" page click
  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  // Use filtered data if searching, otherwise show all data
  const displayData = isSearching ? filteredData : apiData;

  return (
    <Fragment>
      <Row>
        <div className="d-flex justify-content-end mb-3">
          <div className="input-group" style={{ maxWidth: "300px" }}>
            <input
              type="search"
              id="form1"
              className="form-control"
              placeholder="Search here..."
              onChange={handleSearch}
            />
          </div>
        </div>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title className="text-white">Inactive Users</Card.Title>
            </Card.Header>
            <Card.Body>
              <Table
                responsive
                className="table-striped table-bordered table-hover"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>User ID</th>
                    <th>User Wallet</th>
                    <th>Referral ID</th>
                    {/* <th>Referral Address</th> */}
                    <th>Total Team</th>
                    <th>Date & Time</th>
                    <th>Dashboard</th>
                  </tr>
                </thead>
                <tbody>
                  {!displayData?.[0] ? (
                    <tr>
                      <td className="text-light text-center" colSpan="7">
                        No data available
                      </td>
                    </tr>
                  ) : (
                    displayData?.map((data, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{data?.userId}</td>
                        <td>
                          {data?.user?.slice(0, 5)}...{data?.user?.slice(-4)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.user)}
                              size="small"
                              style={{ marginLeft: 4 }}
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        {/* <td>{data?.referrer}</td> */}
                        <td>
                          {data?.referrer?.slice(0, 5)}...
                          {data?.referrer?.slice(-4)}
                          <Tooltip title={tooltipText} arrow>
                            <IconButton
                              onClick={() => handleCopy(data?.referrer)}
                              size="small"
                              style={{ marginLeft: 4 }}
                            >
                              <FaRegCopy />
                            </IconButton>
                          </Tooltip>
                        </td>
                        <td>{data?.teamCount || 0}</td>
                        <td>
                          {new Date(data?.timestamp * 1000).toLocaleString(
                            "en-GB",
                            {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            },
                          )}
                        </td>
                        <td>
                          <a
                            href={`https://dforce.biz/dashboard/?userAddress=${data?.user}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-inline-flex align-items-center gap-2 fw-semibold text-decoration-none text-dark"
                            title="Open User Dashboard"
                          >
                            {/* User / Wallet Icon */}
                            <i className="bi bi-wallet2 text-primary"></i>

                            {/* Short Address */}
                            <span>
                              {data?.user?.slice(0, 5)}...
                              {data?.user?.slice(-4)}
                            </span>

                            {/* External Link Icon */}
                            <i
                              className="bi bi-box-arrow-up-right text-muted"
                              style={{ fontSize: 12 }}
                            ></i>
                          </a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>

              <div className="d-flex justify-content-between">
                <span>
                  <strong>
                    {currentPage} of {totalPages}
                  </strong>
                </span>
                <span> Total users: {TotalUsers}</span>
              </div>

              <div
                className="text-center mb-3 col-lg-6"
                style={{ margin: "auto" }}
              >
                <div className="filter-pagination mt-3">
                  <button
                    className="previous-button btn border m-2"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>

                  <button
                    type="button"
                    className="next-button btn btn-success pointer border m-2"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>

                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <span> Total users: {TotalUsers}</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default InActiveUser;
